import qs from 'qs';
import React, { useState } from 'react';
import styled from 'styled-components';
import { EventHeaderMobile } from 'components/Events/Components/EventHeaderMobile';
import { AutoSuggest } from 'components/Form/AutoSuggest';
import { Select } from 'components/Form/Select';
import Spacer from 'components/Spacer';
import { useGetRefundStatus } from 'components/Transactions';
import { useGetMembershipDivisions } from 'pages/app/AnnualTickets/Members/gql/useGetMembershipDivisions';
import MobileSearchInput from 'pages/employee/Events/search';
import { useGetRegistrationTickets } from './gql/useGetRegistrationTickets';
import { RegistrationsTransactionsListMobile as List } from './RegistrationsTransactionsListMobile';

const FilterContainer = styled.div`
  min-width: 230px;
  margin-left: 25px;

  @media screen and (max-width: 860px) {
    margin-left: 0;
    margin-bottom: 10px;
    padding: 0 10px;
  }
`;

export const RegistrationsMobile = (props) => {
  const { match, location } = props;
  const [search, setSearch] = useState('');
  const { data: tickets, loading } = useGetRegistrationTickets();
  const [ticketFilter, setTicketFilter] = useState(null);
  const [division, setDivision] = useState(null);

  const { data } = useGetRefundStatus();
  const { data: divisions } = useGetMembershipDivisions(
    ticketFilter ? ticketFilter : null
  );

  const { page } = qs.parse(window.location.search.substring(1));

  const handleChange = (e) => setSearch(e.target.value);

  const handleBlur = (e) => {
    setSearch(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      setSearch(e.target.value);
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  const currentPage = parseInt(urlParams.get('page'));

  return loading ? (
    <div></div>
  ) : (
    <div>
      <MobileSearchInput
        placeholder="Search Registrations.."
        onChange={handleChange}
        value={search}
        handleChange={handleChange}
        handleBlur={handleBlur}
        handleKeyPress={handleKeyPress}
      />

      <Spacer size={10} />
      <EventHeaderMobile noDropdown queryDate={'2020-05-23'} noMargin />

      <Spacer size={10} />
      <FilterContainer>
        <Select
          placeholder="All Registrations"
          options={tickets.getRegistrationTickets.map((ticket) => ({
            label: ticket.name,
            value: ticket.id,
          }))}
          value={
            ticketFilter
              ? ticketFilter
              : { label: 'All Registrations', value: null }
          }
          isSearchable
          isClearable
          onChange={({ target }) => {
            setTicketFilter(target.value ?? null);
          }}
        />
      </FilterContainer>

      {ticketFilter &&
      divisions &&
      divisions.getMembershipDivisions &&
      divisions.getMembershipDivisions.length > 0 ? (
        <>
          <Spacer size={10} />
          <FilterContainer>
            <AutoSuggest
              placeholder="Select Division"
              options={divisions.getMembershipDivisions.map((ticket) => ({
                label: ticket,
                value: ticket,
              }))}
              value={division ? division : null}
              isSearchable
              isClearable
              onChange={(ticket) => {
                setDivision(ticket ?? null);
              }}
            />
          </FilterContainer>
        </>
      ) : null}

      <Spacer size={10} />
      <List
        page={page}
        refundEventStatus={data?.getEventRefundStatus}
        currentPage={currentPage}
        match={match}
        location={{ ...location, search: `?queryString=${search}` }}
        queryString={search}
        ticket_id={ticketFilter ? ticketFilter : null}
        division={division ? division.value : null}
      />
    </div>
  );
};
